import { render } from "./retail.vue?vue&type=template&id=e4bfe850&scoped=true"
import script from "./retail.vue?vue&type=script&lang=js"
export * from "./retail.vue?vue&type=script&lang=js"

import "./retail.vue?vue&type=style&index=0&id=e4bfe850&scoped=true&lang=css"
import "./retail.vue?vue&type=style&index=1&id=e4bfe850&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4bfe850"]])

export default __exports__